module.exports = __webpack_public_path__ + "static/media/other_events.4fd490d1.png";